import { render, staticRenderFns } from "./RightsFundRollbackCopy.vue?vue&type=template&id=05b3d938"
import script from "./RightsFundRollbackCopy.vue?vue&type=script&lang=js"
export * from "./RightsFundRollbackCopy.vue?vue&type=script&lang=js"
import style0 from "./RightsFundRollbackCopy.vue?vue&type=style&index=0&id=05b3d938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports